import React, { ReactNode, FC } from 'react'
import { Grid } from '@mui/material'

interface DashboardCardProps {
  /** Content to render inside the card */
  children: ReactNode
}

/**
 * DashboardCard component
 * A styled container for dashboard content cards
 */
const DashboardCard: FC<DashboardCardProps> = ({ children }) => {
  return (
    <Grid
      container
      padding={2}
      sx={{
        height: '100%',
        backgroundColor: theme => theme.palette.primary.contrastText,
        borderRadius: theme => theme.spacing(3)
      }}
    >
      <Grid
        item
        xs={12}
        container
        spacing={1}
        sx={{ paddingLeft: 2, paddingTop: 2 }}
      >
        {children}
      </Grid>
    </Grid>
  )
}

export default DashboardCard
